import React from 'react';
import { Redirect } from 'react-router-dom';

import './index.css';
import Preloader from "../../utils/preloader";
import API from "../../utils/api";
import {reachGoal} from "../../utils/utils";

class NewCourse extends React.Component {
    constructor (props) {
        super();
        this.state = {
            not_allowed: false,
            loading: true,
            id: null
        }
    }

    createNewCourse = () => {
        const t = this;

        API.post('/whub/v3/course')
            .then(function (r) {
                const id = r.data.draft_course_id ? r.data.draft_course_id : r.data.id;
                t.setState({id: id});
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    componentDidMount() {
        document.body.classList.add('no_search');

        reachGoal(80212912,'new_course_click');
        this.createNewCourse();

    };
    componentWillUnmount() {
        document.body.classList.remove('no_search');
    };

    render() {
        const redirect = this.state.id ? <Redirect to={{pathname: '/course/' + this.state.id + '/edit/general'}}/> : '';
        const preloader = this.state.loading ? <Preloader/> : '';

        return (
            <div className="course_create_wrapper">
                <div className="cc_top">
                    <h1>создание курса</h1>
                    {preloader}
                    {redirect}
                </div>

            </div>
        );
    }
}

export default NewCourse;